export const applianceDataGridProps = {
    choiceColumns: true,
    defaultColumns: ['applianceType', 'brand', 'series', 'seriesVersion'],
};
/**
 * @param {string} applianceType - The appliance type to check
 * @returns {string[]} The units associated with the appliance type
 */
export const getUnits = (applianceType) => {
    const unitsMap = {
        LC: ['WM', 'TD'],
    };
    return unitsMap[applianceType] || [];
};
